import DownloadFile from './container';

export default DownloadFile;
